/** Display only. Integer arithmetic preserves V2's four percentage decimal places. */
export function formatRewardRate(rate: number | null, denominator: number | null): string | null {
  if (rate === null || !Number.isSafeInteger(rate) || rate < 0 ||
    denominator !== 10_000 && denominator !== 1_000_000 || rate > denominator) return null;
  const scale = BigInt(denominator) / 100n;
  const value = BigInt(rate);
  return `${value / scale}.${String(value % scale).padStart(denominator === 10_000 ? 2 : 4, "0")}%`;
}

export function nftRewardPercent(nft: { rewardBps: number | null; rewardRate?: number | null;
  rewardDenominator?: number | null; rewardPolicyVersion?: string | null }): string {
  // Unversioned demo/legacy producers retain BPS; explicit unknown API data stays unknown.
  const legacy = nft.rewardPolicyVersion === undefined && nft.rewardRate === undefined;
  return formatRewardRate(legacy ? nft.rewardBps : nft.rewardRate ?? null,
    legacy ? 10_000 : nft.rewardDenominator ?? null) ?? "—";
}
